import React, { FC, memo } from 'react';
import { Link } from 'react-router';

import logo from '@assets/logos/logo.png';

import { PATH_INDEX } from '@constants/common/routes.constants';

import HeaderButtons from '../HeaderButtons';
import useStyles from './styles.module';

interface Props {
  onClose: () => void;
}

const MobileMenu: FC<Props> = ({ onClose }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Link to={PATH_INDEX} className={classes.link}>
        <img src={logo} className={classes.logo} alt="logo" />
      </Link>
      <HeaderButtons onClose={onClose} />
    </div>
  );
};

export default memo(MobileMenu);
